import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white
    },
    content: {
        marginTop: 18,
        backgroundColor: baseColors.green.light,
        borderRadius: 10
    },
    item: { paddingHorizontal: 18 },
    divider: { height: 2, backgroundColor: baseColors.orange.primary, width: "90%", alignSelf: "center" },
    titleStyle: {
        marginBottom: 10,
        fontSize: 14,
        fontFamily: baseFontFamily.OpenSansSemiBold,
        color: baseColors.green.primary
    },
    descriptionStyle: {
        fontSize: 12,
        fontFamily: baseFontFamily.OpenSansSemiBold,
        color: baseColors.black
    },
    contactUsItem: { marginVertical: 10 }
})

export default styles
